import {useParams} from 'react-router-dom';

import {defaultTo} from 'ramda';

import {queryParams} from '@dms/shared';

import {useQueryState} from 'shared/web';

type WorkshopIdParams = {
  id?: string;
};

export function useWorkshopUrl() {
  const params = useParams<WorkshopIdParams>();
  const [addLabourJobId] = useQueryState(queryParams.SERVICE_CASE_ADD_LABOUR_JOB_ID);
  const [addMaterialRequestJobId] = useQueryState(
    queryParams.SERVICE_CASE_ADD_MATERIAL_REQUEST_JOB_ID
  );
  const [orderId] = useQueryState(queryParams.SERVICE_CASE_ORDER_ID);
  const [serviceOrderReturnId] = useQueryState(queryParams.SERVICE_ORDER_RETURN_ID);
  const [serviceOrderReturnAuthorizationProfileId] = useQueryState(
    queryParams.SERVICE_ORDER_RETURN_AUTHORIZATION_PROFILE_ID
  );

  return {
    serviceCaseId: defaultTo('', params.id),
    addLabourJobId: defaultTo('', addLabourJobId),
    addMaterialRequestJobId: defaultTo('', addMaterialRequestJobId),
    orderId: defaultTo('', orderId),
    serviceOrderReturnId: defaultTo('', serviceOrderReturnId),
    serviceOrderReturnAuthorizationProfileId: defaultTo(
      '',
      serviceOrderReturnAuthorizationProfileId
    ),
  };
}
